<script>
export default {
	name: 'IconSvgGzip',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4781 4.104C13.0134 4.10333 12.5678 3.92198 12.2392 3.5997C11.9107 3.27743 11.7259 2.84055 11.7254 2.3849V0H3.89355C3.28691 0 2.70511 0.236249 2.27615 0.656782C1.84719 1.07731 1.6062 1.64769 1.6062 2.24241V15.7602C1.6071 16.3543 1.84849 16.9238 2.27735 17.3436C2.70621 17.7635 3.28749 17.9993 3.89355 17.9992H13.2954C13.9015 17.9993 14.4827 17.7635 14.9116 17.3436C15.3405 16.9238 15.5818 16.3543 15.5827 15.7602V4.104H13.4781Z"
				:fill="color" />
			<path
				d="M15.5828 4.104H13.4782C13.0134 4.10333 12.5678 3.92198 12.2393 3.5997C11.9107 3.27743 11.7259 2.84055 11.7255 2.3849V0L15.5828 4.104Z"
				fill="#FFBC00" />
			<path
				d="M17.2411 14.2169H6.61266C5.85873 14.2169 5.24756 14.8161 5.24756 15.5552V18.6617C5.24756 19.4008 5.85873 20 6.61266 20H17.2411C17.995 20 18.6062 19.4008 18.6062 18.6617V15.5552C18.6062 14.8161 17.995 14.2169 17.2411 14.2169Z"
				fill="#FFBC00" />
			<path
				d="M11.8247 17.8684H12.9527V18.3575H11.1379V17.8967L12.248 16.3376H11.1524V15.8518H12.9459V16.3126L11.8247 17.8684Z"
				fill="#F3F3F6" />
			<path d="M13.9502 15.8518V18.3575H13.3348V15.8518H13.9502Z" fill="#F3F3F6" />
			<path
				d="M14.995 17.4784V18.3575H14.3771V15.8518H15.375C15.6784 15.8518 15.9105 15.9251 16.0694 16.0735C16.1499 16.1508 16.2128 16.2439 16.2539 16.3467C16.2951 16.4496 16.3136 16.5598 16.3083 16.6701C16.3109 16.8159 16.274 16.9597 16.2012 17.0868C16.127 17.211 16.017 17.311 15.885 17.3742C15.7257 17.4477 15.551 17.4834 15.375 17.4784H14.995ZM15.6818 16.6701C15.6818 16.4507 15.5577 16.3396 15.3095 16.3368H14.995V16.9884H15.3095C15.5577 16.9912 15.6818 16.8851 15.6818 16.6701Z"
				fill="#F3F3F6" />
			<path d="M8.18448 17.785V18.3908H7.54443V17.785H8.18448Z" fill="#F3F3F6" />
			<path
				d="M10.4863 16.0644C10.6883 16.216 10.8244 16.4394 10.8663 16.6885H10.2247C10.1828 16.5991 10.1148 16.5244 10.0297 16.4744C9.93421 16.4177 9.82481 16.3888 9.71382 16.391C9.62753 16.3875 9.54152 16.403 9.46188 16.4364C9.38225 16.4698 9.31093 16.5203 9.25298 16.5844C9.13106 16.7303 9.06911 16.917 9.07965 17.1069C9.07965 17.3452 9.14048 17.5282 9.26215 17.656C9.33056 17.7224 9.41208 17.7737 9.50149 17.8067C9.59089 17.8397 9.68621 17.8537 9.78132 17.8477C9.91729 17.8502 10.0504 17.8083 10.1605 17.7285C10.2729 17.6446 10.3541 17.5255 10.3913 17.3902H9.62549V16.9544H10.898V17.5535C10.849 17.7025 10.7721 17.8409 10.6713 17.961C10.5617 18.0901 10.4255 18.1942 10.2722 18.266C10.0986 18.3462 9.90915 18.3861 9.71799 18.3827C9.48547 18.3888 9.25548 18.3333 9.05132 18.2219C8.86456 18.1168 8.71251 17.9596 8.61382 17.7694C8.50778 17.5634 8.4548 17.3343 8.45966 17.1027C8.45549 16.8725 8.50846 16.6449 8.61382 16.4402C8.71234 16.2504 8.86371 16.0933 9.04965 15.9877C9.25076 15.8769 9.47763 15.8214 9.70715 15.8269C9.98611 15.8168 10.2604 15.9004 10.4863 16.0644Z"
				fill="#F3F3F6" />
			<path
				d="M8.5933 12.7095C8.30744 12.7091 8.03343 12.5975 7.83138 12.3993C7.62933 12.201 7.51573 11.9323 7.5155 11.6521V10.5946H9.67195V11.6521C9.67173 11.9324 9.55801 12.2013 9.35577 12.3996C9.15353 12.5978 8.87931 12.7093 8.5933 12.7095ZM8.06715 11.1354V11.6521C8.06715 11.7889 8.12256 11.9202 8.2212 12.0171C8.31985 12.114 8.45368 12.1685 8.5933 12.1687C8.733 12.1685 8.86691 12.114 8.9657 12.0171C9.06448 11.9203 9.12007 11.789 9.1203 11.6521V11.1354H8.06715Z"
				fill="#FFBC00" />
			<path d="M7.51438 10.5955H8.59558V9.5355H7.51438V10.5955Z" fill="#FFBC00" />
			<path d="M8.59324 9.53625H9.67444V8.4763H8.59324V9.53625Z" fill="#FFBC00" />
			<path d="M7.51438 8.47717H8.59558V7.41722H7.51438V8.47717Z" fill="#FFBC00" />
			<path d="M8.59324 7.41797H9.67444V6.35802H8.59324V7.41797Z" fill="#FFBC00" />
		</svg>

	</div>
</template>

<style scoped>

</style>